import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';

import { AccountActivatedRoutingModule } from './account-activated-routing.module';
import { AccountActivatedComponent } from './account-activated.component';

@NgModule({
  imports: [MatIconModule, MatButtonModule, CommonModule, FuseSharedModule, AccountActivatedRoutingModule],
  declarations: [AccountActivatedComponent],
})
export class AccountActivatedModule {}
